<template>
  <div class="between-steps-modal">
    <span
      class="between-steps-modal__title"
      v-text="i18n('entities.inscription.almostDone.title')"
    />
    <div class="between-steps-modal__title-separator" />

    <div class="between-steps-modal__content">
      <div class="between-steps-modal__content__steps">
        <el-steps
          :active="1"
          align-center
          finish-status="success"
        >
          <el-step>
            <span
              class="between-steps-modal__content__steps__label between-steps-modal__content__steps__label--grey "
              slot="title"
              v-text="i18n('entities.inscription.almostDone.step1.label')"
            />
            <span
              class="between-steps-modal__content__steps__caption between-steps-modal__content__steps__caption--grey between-steps-modal__content__steps__caption--regular"
              slot="description"
              v-text="i18n('entities.inscription.almostDone.step1.caption')"
            />
          </el-step>
          <el-step>
            <span
              class="between-steps-modal__content__steps__label"
              slot="title"
              v-text="title"
            />
            <div slot="description">
              <span
                class="between-steps-modal__content__steps__caption"
                v-html="`${i18n('entities.inscription.almostDone.step2.caption')}`"
              />
              <p
                class="between-steps-modal__content__steps__caption between-steps-modal__content__steps__caption--regular"
                v-html="`${title ? title.replace(' - ', ' ') : ''}`"
              />
            </div>
          </el-step>
        </el-steps>
      </div>

      <el-button
        type="primary"
        class="between-steps-modal__button"
        @click="onContinue"
      >
        <span v-text="i18n('common.continue')" />
      </el-button>
    </div>
  </div>
</template>

<script>
// import { mapMutations } from 'vuex'

import { i18n } from '@shared/i18n'
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'between-steps-modal',
  data() {
    return {
      i18n,
    }
  },
  computed: {
    ...mapGetters({
      title: 'title',
    }),
  },
  methods: {
    ...mapMutations({
      setBetweenStepsModalVisible: 'setBetweenStepsModalVisible',
    }),
    onContinue() {
      this.setBetweenStepsModalVisible(false)
    },
  },
}
</script>

<style lang="scss" scoped>
.between-steps-modal {
  @include modal-mixin;

  &__content {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    grid-gap: 32px;
    align-items: center;
    justify-items: center;
    justify-content: center;
    margin: 0 auto;

    &__steps {
      width: 100%;
      box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
      padding: 32px 0;
      margin: 8px 0;
      background-color: #FFFFFF;

      &__label {
        font-size: 12px;
        font-weight: bold;
        letter-spacing: -0.21px;
        text-align: center;
        color: #404040;
        padding: 4px 0;
        display: inline-block;

        &--grey {
          color: #c5c5c5;
        }
      }

      &__caption {
        font-size: 20px;
        font-weight: bold;
        letter-spacing: normal;
        text-align: center;
        color: #404040;

        &--grey {
          color: #c5c5c5;
        }

        &--regular {
          font-weight: normal;
          margin-top: 4px;
        }
      }
    }
  }

  &__button {
    width: 212px;
  }
}
</style>
